import style from 'styled-components';

export const StyledCancelConfirmationModal = style.div`  
`;
